<template>
  <div>
    <button id="openbutton" type="button" class="dropdown-toggle bg-blue pull-right button hoverable" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <div class="anim"></div>Open <img src="../../assets/ic_down_White.png">
    </button>
    <div v-if="promptBeforeResetting" class="tooltip error-tooltip non-dropdown-closer reset-button" >
      <a class="canceltooltip" href="#" @click="promptBeforeResetting = false"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
      <p>You may want to save your experiment first! <a href="#" @click="confirmReset">Confirm Restart</a></p>
    </div>
    <div class="dropdown-menu box">
      <div class="add-header">
        <h3 class="pull-left">New Experiment</h3>
        <a href="#" class="button hoverable bg-white sm blue create pull-right" v-bind:class="{'non-dropdown-closer': !($store.state.experimentSaved)}" @click="newExperimentClicked">Create New</a>
      </div>
      <div class="baron">
        <div id="scrollable-box" class="baron__scroller">
          <div class="inner-txt">
            <ul v-if="$store.state.savedExperiments.length > 0" class="list">
              <li class="noborder">
                <h3>Saved Experiment{{ ($store.state.savedExperiments.length !== 1) ? 's' : '' }}</h3>
              </li>
              <li v-for="savedExperiment in $store.state.savedExperiments" :key="savedExperiment.name">
                <p class="txtwrap">{{ savedExperiment.name }}</p>
                <span class="date">Saved on {{ formatDate(savedExperiment.date) }}</span>
                <div class="btn-group">
                  <div v-if="promptBeforeLoading === savedExperiment.name" class="tooltip error-tooltip non-dropdown-closer load-button" >
                    <a class="canceltooltip" href="#" @click="promptBeforeLoading = null"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
                    <p>You may want to save your experiment first! <a href="#" @click="confirmLoad(savedExperiment)">Confirm Load</a></p>
                  </div>
                  <button type="button" class="button hoverable sm bg-blue pull-left" @click="loadExperimentClicked(savedExperiment)" v-bind:class="{'non-dropdown-closer': !($store.state.experimentSaved)}">Load</button><span class="space">&nbsp;</span>
                  <!--<button type="button" class="remove-button non-dropdown-closer button hoverable sm bg-green">Remove</button>-->
                  <div v-if="promptBeforeRemoving === savedExperiment.name" class="tooltip error-tooltip non-dropdown-closer remove-button" >
                    <a class="canceltooltip" href="#" @click="promptBeforeRemoving = null"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
                    <p>This will permanently delete your data! <a href="#" @click="confirmUnsave(savedExperiment)">Confirm</a></p>
                  </div>
                   <a href="#" @click="unsaveExperimentClicked(savedExperiment)" class="non-dropdown-closer remove-button link pull-left button hoverable">Remove</a>
                </div>
              </li>
            </ul>
            <p v-else-if="!($store.state.isLoggedIn)">To see saved items, you must<br> <a href="#" @click="$store.commit('LOGIN_REQUESTED')" class="blue">Sign in</a> or <a class="blue" href="#" @click="$store.commit('LOGIN_REQUESTED')">Sign up</a></p>
            <p v-else>No experiments are currently saved.</p>
          </div>
        </div>
        <div class="baron__track">
          <div class="baron__bar"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import routeGlobals from '../../mixins/routeGlobals'

export default {
  name: 'OptionDropdown',
  mixins: [routeGlobals],
  data () {
    return {
      promptBeforeRemoving: null,
      promptBeforeLoading: null,
      promptBeforeResetting: false
    }
  },
  methods: {
    newExperiment () {
      this.$store.commit('SET_EXPERIMENT_NAME', null)
      this.$store.commit('RESET_EXPERIMENT')
      this.initExperimentClasses()
      this.initExperimentWindow()
    },
    newExperimentClicked () {
      if (this.$store.state.experimentSaved) {
        this.newExperiment()
      } else this.promptBeforeResetting = true
    },
    confirmReset (savedExperiment) {
      this.promptBeforeResetting = false
      $('body').trigger('click') // make sure open experiment dropdown closes
      this.newExperiment()
    },
    confirmUnsave (savedExperiment) {
      this.promptBeforeRemoving = null
      this.unsaveExperiment(savedExperiment)
    },
    unsaveExperimentClicked (savedExperiment) {
      this.promptBeforeRemoving = savedExperiment.name
    },
    unsaveExperiment (savedExperiment) {
      this.$store.commit('UNSAVE_EXPERIMENT', savedExperiment)
    },
    formatDate (unformattedDateTime) { // adapted from stackoverflow
      if ((typeof (unformattedDateTime) === 'string') || (typeof (unformattedDateTime) === 'number')) {
        unformattedDateTime = new Date(unformattedDateTime)
      } // after stringify-parse or storage to firebase
      let dd = unformattedDateTime.getDate()
      let mm = unformattedDateTime.getMonth() + 1 // January is 0!
      let yyyy = unformattedDateTime.getFullYear()
      // if(dd<10) {
      //    dd = '0'+dd
      // }
      // if(mm<10) {
      //    mm = '0'+mm
      // }
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let monthName = monthNames[mm - 1]
      // let formattedDate = mm + '/' + dd + '/' + yyyy
      let formattedDate = monthName + ' ' + dd + ', ' + yyyy
      return formattedDate
    },
    confirmLoad (savedExperiment) {
      this.promptBeforeLoading = null
      $('body').trigger('click') // make sure open experiment dropdown closes
      this.loadExperiment(savedExperiment)
    },
    loadExperimentClicked: function (savedExperiment) {
      if (this.$store.state.experimentSaved) {
        this.loadExperiment(savedExperiment)
      } else this.promptBeforeLoading = savedExperiment.name
    },
    loadExperiment (savedExperiment) {
      this.$store.dispatch('LOAD_EXPERIMENT', savedExperiment.experimentData)
    }
  },
  mounted: function () {
    $(document).on('click', '.non-dropdown-closer', function (e) {
      e.stopPropagation()
    })
    let vm = this
    $(document).on('click', function () {
      vm.promptBeforeRemoving = null
      vm.promptBeforeLoading = null
      vm.promptBeforeResetting = false
    })
  }
}
</script>
<style scoped>
  .btn-group.open .dropdown-toggle,
  .btn-group .dropdown-toggle:focus,
  .btn-group .dropdown-toggle:active{
    color: #fff;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.4);
  }
  .dropdown-menu.box{
    padding: 0;
    margin: 12px 0 0;
    border-radius: 0;
    right: 0 !important;
    width: 382px;
    height: 513px;
    font-size: 16px;
    line-height: 20px;
    background-color: #ffffff;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.32);
    border:1px solid #cdcdcd;
    z-index: 99999;

    position: absolute;
    transform: inherit !important;
    top: 100% !important;
    left: auto !important;
    will-change: inherit !important;
  }

  .dropdown-menu.box:after {
    top: -15px;
    right: 40px;
    position: absolute;
    content:" ";
    height: 15px;
    width: 26px;
    z-index: 999;
    position: absolute;
    background: url("../../assets/angle.png") no-repeat;
  }

  /*.dropdown-menu.box:after, .dropdown-menu.box:before {*/
    /*bottom: 100%;*/
    /*right: 10%;*/
    /*border: solid transparent;*/
    /*content: " ";*/
    /*height: 0;*/
    /*width: 0;*/
    /*position: absolute;*/
    /*pointer-events: none;*/
    /*z-index: 100;*/
  /*}*/

  /*.dropdown-menu.box:after {*/
    /*border-color: rgba(246,246,246, 0);*/
    /*border-bottom-color: #f6f6f6;*/
    /*border-width: 12px;*/
    /*margin-left: -12px;*/
  /*}*/
  /*.dropdown-menu.box:before {*/
    /*!*border-color: rgba(63, 63, 68, 0.05);*!*/
    /*border-bottom-color: #4c4c4c;*/
    /*border-width: 12px;*/
    /*margin-left: -12px;*/
  /*}*/
  .add-header{
    overflow: hidden;
    padding: 14px 15px;
    border-radius: 1px;
    position: relative;
    z-index:100;
    background-color: #f6f6f6;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.48);
  }
  .add-header h3{margin: 3px 0 0;}
  .inner-txt{
    padding: 20px 20px 20px 14px;
    overflow: hidden;
  }
  .inner-txt h3{
    margin: 0 0 20px;
  }
  .inner-txt p{margin: 0 0 15px;}
  .inner-txt p a{
    padding:  0 0 1px;
    border-bottom: solid 1px #007ee5;
  }
  .inner-txt .list{
    padding: 0;
    min-height: 0px
  }
  .inner-txt .list li:first-child{
    padding: 0 0 17px;
    margin: 0;
  }
  .inner-txt .list li .bt{margin: 0;}
  .inner-txt .list li{
    height: inherit;
    padding: 18px 0 26px;
    border-bottom: solid 1px #dedede;
  }
  .inner-txt .list li .txtwrap{
    margin: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width:354px;
  }
  .inner-txt .list li .date{
    font-size: 14px;
    margin: 0 0 14px;
    display: block;
  }
  .inner-txt .link{
    color: #656565;
    margin: 5px 0 0 12px;
    box-shadow: none;
    min-width: inherit;
    padding: 0;
    height: auto;
    line-height: 20px;
    text-decoration: underline;
  }
  .error-tooltip{
    display:block;
  }
  .error-tooltip p a{
    color: #007ee5;
  }
  .load-button:before, .load-button:after{
    left: 35px;
  }
  .reset-button{
    left: 183px;
    top: -51px;
    height: 92px;
    z-index: 999999;
  }
  .inner-txt .list li.noborder{
    border-style: none;
    padding: 18px 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/experiment/optionDropdown.vue